import { action } from 'satcheljs';

/**
 * Action to show/hide scheduling assistant.
 */
export let setShowSchedulingAssistant = action(
    'setShowSchedulingAssistant',
    (showSchedulingAssistant: boolean) => ({
        showSchedulingAssistant: showSchedulingAssistant,
    })
);
